var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedizinrecht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.53 159.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.33,159.73v-30.65c2.18-.1,4.2-1.14,5.32-3.03,1.66-2.82.85-6.51-1.89-8.28-3.85-2.5-9.78.61-13.44-2.33-2.98-2.39-3.11-7.03-.17-9.5,4.49-3.78,11.87,1.34,15.37-4.33,1.19-1.92,1.2-4.45.07-6.41-3.51-6.09-11.54-.3-15.89-4.9-1.93-2.05-2.15-5.31-.62-7.68,3.68-5.72,11.85.04,15.97-4.85,3-3.57,1.13-9.1-3.45-10.03-4.61-.94-11.64,2.14-13.16-4.95-.41-1.9-.12-3.99,1.15-5.46,4.06-4.68,12.46,1.09,16.05-5.01,2.32-3.94-.27-8.91-4.8-9.29s-10.34,1.52-12.43-3.92c-1.41-3.66,1.27-8.41,5.29-8.41h6.62V.03h124.31c5.46,0,11.17-1.19,10.89,12.04v135.85c-.65,11.33-.59,11.56-8.18,11.74-.59.01-2.18.07-2.71.07H12.33ZM77.13,36.93c-31.82,1.74-50.55,37.55-34.15,64.99,16.89,28.26,58.08,27.81,74.34-.81,17.01-29.93-6.19-66.04-40.19-64.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.82,60.46c.12-.78,4.65-5.12,5.98-5.15,1.18-.03,6.22,4.38,6.22,5.15v13.14l.17.17h13.13c1.03.01,5.14,4.02,5.14,6.09s-4.12,6.14-5.14,6.12h-13.13l-.17.17v13.14c-.02,1.36-4.11,5.15-6.27,5.15-2.03,0-5.95-3.79-5.94-5.15v-13.14l-.17-.17h-13.13c-.87.04-5.17-5.27-5.13-6.46.03-1.34,4.41-5.75,5.13-5.75h13.13l.17-.17v-13.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedizinrecht);
export default __webpack_public_path__ + "static/media/Medizinrecht.e1bd374e8f1f634b27b0c563a1e85d38.svg";
export { ForwardRef as ReactComponent };